import CommonMomentAndAttendance from '../commonfile/CommonMomentAndAttendance'

const ZoneHeadMomentAtd = () => {
    return (
        <>
            <CommonMomentAndAttendance />
        </>
    )
}

export default ZoneHeadMomentAtd